class Imagenes {
    buscar(frase,cargarImagen) {
        let palabra = this.selecccionarPalabra(frase);
        fetch('https://webtvapi.mircloud.us/api/imagen4.php?palabra='+palabra)
        .then((response) => response.json())
        .then((json) => {
            let imgs =JSON.parse(json.data.imagenes.img);
            console.log(json);
            let src = "";
            if (imgs && imgs.length > 0) {
                src = imgs[Math.floor(Math.random() * imgs.length)];
            }
            cargarImagen(src);
        });
    }
    selecccionarPalabra(frase) {
        let palabras = frase.split(' ');
        for (const palabraToda of palabras) {
            for (const palabraComun of this.getPalabrasComunes()) {
                if (palabraToda === palabraComun) {
                    const index = palabras.indexOf(palabraComun);
                    if (index > -1) {
                        palabras.splice(index, 1);
                    }
                }
            }
        }
        let palabra = palabras[Math.floor(Math.random() * palabras.length)];
        return palabra;
    }
    getPalabrasComunes() {
        return ["de","la","que","el","en","y","a","los","las","se",
        "sus","una","vez","mas","lo","va","Mmm","esta","los","es","son","eres","tu","ella","el","ellos","que","ha","partir",
        "del","segun","mmm",
        "","\\,","\\.",":",
        "\"","-","_","@","#","?","¿","!","¡"];
    }
}
export default Imagenes;